import { QueryToSqlHelper } from '../../api/query-to-sql-helper';
import { MetricGroupId } from '../../v2/api/types-graphql';
import { FilterTypes } from '../../v2/common/components/filter/filterbar/types';
import { MetricTypes } from '../../v2/common/types';
import { MetricStore } from '../metric-store';

// TO be used only in this folder
export const TO_BE_DEPRECATED_getFilterConditionsForMetricGroup = <
  T extends FilterTypes,
>(
  filters: T[],
  metricGroupId: MetricGroupId,
  metricStore: MetricStore,
  isSegmentation = false
) => {
  // Won't pass empty cohort filter for segmentation
  const needsEmptyCohortFilter =
    !isSegmentation &&
    metricStore.metricGroupNeedsEmptyCohortFilter(metricGroupId);
  if (metricStore.isMetricGroupRegular(metricGroupId)) {
    return QueryToSqlHelper.getFilterConditions(
      filters,
      MetricTypes.REGULAR,
      needsEmptyCohortFilter
    );
  } else if (metricStore.isMetricGroupCohort(metricGroupId)) {
    return QueryToSqlHelper.getFilterConditions(
      filters,
      MetricTypes.COHORT,
      needsEmptyCohortFilter
    );
  } else if (metricStore.isMetricGroupEmployeeCohort(metricGroupId)) {
    return QueryToSqlHelper.getFilterConditions(
      filters,
      MetricTypes.EMPLOYEE_COHORT,
      needsEmptyCohortFilter
    );
  }
};
